import { CheckCircle, XCircle } from 'lucide-react';

export function PaymentSuccessPage() {
  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        <CheckCircle size={56} className="payment-result-icon ok" />
        <h1>¡Pago completado!</h1>
        <p>Tu suscripción <strong>White Bot Pro</strong> está activa.</p>
        <p className="payment-result-sub">
          En unos segundos tu licencia quedará activada. Accede al dashboard para vincular tu slot.
        </p>
        <a href="/dashboard" className="payment-result-btn">Ir al dashboard</a>
      </div>
    </div>
  );
}

export function PaymentCancelPage() {
  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        <XCircle size={56} className="payment-result-icon bad" />
        <h1>Pago cancelado</h1>
        <p>No se ha realizado ningún cargo.</p>
        <p className="payment-result-sub">
          Puedes volver y completar el proceso cuando quieras.
        </p>
        <a href="/#productos" className="payment-result-btn secondary">Ver planes</a>
      </div>
    </div>
  );
}
